import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <AboutSection />
        <CarouselSection />
        <IndexSection />
        <CardsSection />
        <RankingSection />
        <UpdatesSection />
        <FaqSection />
        <ContactSection />
        <AppSection />
        <TopicsSection />
        <CommentsSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}